import React, { FunctionComponent } from 'react';
import Slider from 'react-slick';
import { useSlickReady } from '../../../hooks/useSlickReady';
import { RelatedRecruitmentsListState } from './types';
import { ContentCard } from '../../molecules/contentCard';

type Props = {
  state: RelatedRecruitmentsListState;
};

export const Presentation: FunctionComponent<Props> = ({ state }) => {
  const ready = useSlickReady(state.recruitments.length > 0);

  const isMobile = window.innerWidth <= 780;
  const settings = {
    infinite: true,
    speed: 300,
    slidesToShow: isMobile ? 1 : 4,
    slidesToScroll: isMobile ? 1 : 4,
    arrows: !isMobile,
    dots: isMobile,
    responsive: [
      {
        breakpoint: 780,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <aside className="l-related-articles p-related-articles">
      <h2 className="p-related-articles__heading">関連する求人</h2>
      <div className="p-related-articles__inner">
        {ready && (
          <Slider
            {...settings}
            className="p-related-articles__list"
          >
            {state.recruitments.map((recruitment) => (
              <div key={recruitment.id}>
                <ContentCard
                  id={recruitment.id}
                  title={recruitment.title}
                  companyName={recruitment.companyName}
                  companyIcon={recruitment.companyIcon}
                  image={recruitment.image}
                  type="recruitment"
                />
              </div>
            ))}
          </Slider>
        )}
      </div>
      <div className="p-related-articles__readmore p-related-articles__readmore--pc">
        <a href="/" data-event="click" data-category="eventcontent" data-value="more_related_recruitments">
          READ MORE...
        </a>
      </div>
      <div className="p-related-articles__readmore p-related-articles__readmore--sp">
        <a href="/" data-event="click" data-category="eventcontent" data-value="more_related_recruitments">
          もっとみる
        </a>
      </div>
    </aside>
  );
};
